import { ComponentFactoryResolver, ComponentRef, Injectable, Injector, OnDestroy, ReflectiveInjector } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Injectable()
export class ComponentFactoryService implements OnDestroy {

    private componentRef: ComponentRef<any>;

    constructor(
        private resolver: ComponentFactoryResolver,
        private injector: Injector
    ) { }

    createComponent(component: any): ComponentRef<any> {
        const factory = this.resolver.resolveComponentFactory(component);        
        this.componentRef = factory.create(this.injector);
        return this.componentRef;
    }

    createModalComponent(component: any, data: any): ComponentRef<any> {
        const factory = this.resolver.resolveComponentFactory(component);
        
        const dialogRef = { close: (result: any) => console.log('Result:', result) };

        const injector = ReflectiveInjector.resolveAndCreate([
            { provide: MatDialogRef, useValue: dialogRef },
            { provide: MAT_DIALOG_DATA, useValue: data }
          ], this.injector);
        this.componentRef = factory.create(injector);
        return this.componentRef;
    }

    ngOnDestroy() {
        if (this.componentRef)
            this.componentRef.destroy();
    }
}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/services/component-factory.service.ts